var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer"},[_c('img',{staticClass:"null_",attrs:{"src":require("@/assets/image/common/noh.webp"),"alt":"null"}}),_c('div',[_vm._v("没有查询到相关内容噢")])])
}]

export { render, staticRenderFns }